<template>
  <div class="modal" v-if="showModal">
    <div class="modal-content">
      <div class="modal-header">
        <h3>Double Insurance</h3>
      </div>
      <div class="modal-body">
        <p>Your Vehicle has an active cover with APA Insurance Ltd, Cert No: C30535354 which expires on 28/11/2024. Cancel the existing cover or select a different date to proceed.</p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-cancel" @click="toggleModal">CANCEL COVER</button>
        <button class="btn btn-change" @click="toggleModal">CHANGE START DATE</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DoubleInsurance',
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: #fefefe;
  border: 1px solid #888;
  width: 400px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.modal-header {
  padding: 16px;
  background-color: #4169e1;
  color: white;
}

.modal-body {
  padding: 16px;
}

.modal-footer {
  padding: 16px;
  background-color: #4169e1;
  color: white;
  display: flex;
  justify-content: space-between;
}

.btn {
  border: none;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}

.btn-cancel {
  background-color: #e74c3c;
  color: white;
}

.btn-change {
  background-color: #2980b9;
  color: white;
}
</style>
